import styled from "styled-components"
import { media } from "../../mediaStylesNew"
import { colors } from "../../Color"
import margins from "../../MarginContainer"
import getFontsByProps from "../../getFontsByProps"

const size = {
  small: "16px",
  medium: "18px",
  large: "20px",
}

const themedColor = {
  light: colors.coal,
  dark: colors.paleBeige,
  teal: colors.white,
}

const Text = styled.div`
  > a {
    text-decoration: none;
    cursor: pointer;
    color: ${props =>
      props.color
        ? colors[props.color]
        : props.theme
        ? themedColor[props.theme]
        : colors.white};
  }
  position: relative;
  z-index: 9;
  display: block;
  overflow-wrap: initial;
  color: ${props =>
    props.color
      ? colors[props.color]
      : props.theme
      ? themedColor[props.theme]
      : colors.primary};
  font-size: ${props => (props.size ? size[props.size] : size.large)};
  font-family: ${getFontsByProps};
  font-weight: ${props => (props.bold ? 600 : 400)};
  line-height: 1.5em;

  ${media.small`
    font-size: ${props => (props.size ? size[props.size] : size.small)};
    font-weight: ${props => (props.highlight ? 600 : 400)};
  `};

  ${margins};
`

export default Text
